import React, { useRef, useEffect, useState, useCallback } from "react";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import Box from "@mui/material/Box";
import SearchIcon from "@mui/icons-material/Search";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import CssBaseline from "@mui/material/CssBaseline";
import AppBar from "@mui/material/AppBar";
import MenuIcon from "@mui/icons-material/Menu";
import { alpha } from "@mui/material/styles";
import makeStyles from "@mui/styles/makeStyles";
import Badge from "@mui/material/Badge";
import Button from "@mui/material/Button";
import Fab from "@mui/material/Fab";
import AddIcon from "@mui/icons-material/Add";
import CreateEditAccount from "./CreateEditAccount";
import CreateAccountViaCSV from "./CreateAccountViaCSV";
import ViewAccountInformation from "./ViewAccountInformation";
import AccountsForApprovalDialog from "./accountsForApproval/AccountsForApprovalDialog";
import LinearProgress from "@mui/material/LinearProgress";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Avatar from "@mui/material/Avatar";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles";
import { createTheme } from "@mui/material";
import Papa from "papaparse";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import TableHead from "@mui/material/TableHead";
import Paper from "@mui/material/Paper";
import axios from "axios";

// QR CODE
import ReactDOM from "react-dom";
import QRCode from "react-qr-code";
import { QrReader } from "react-qr-reader";
import QrCodeIcon from "@mui/icons-material/QrCode";

const drawerWidth = 300;

const materialTheme = createTheme({
  // set default for now
});
const useStyles = makeStyles((theme) => ({
  appBar: {
    [theme.breakpoints.up("sm")]: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
    },
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up("sm")]: {
      display: "none",
    },
  },
  search: {
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.common.white, 0.15),
    "&:hover": {
      backgroundColor: alpha(theme.palette.common.white, 0.25),
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing(3),
      width: "auto",
    },
  },
  appBarBottom: {
    top: "auto",
    bottom: 0,
    backgroundColor: "#ffffff",
    [theme.breakpoints.up("sm")]: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
    },
  },
  grow: {
    flexGrow: 1,
  },
}));

function Accounts(props) {
  const classes = useStyles();
  const [openCreateEditAccount, setOpenCreateEditAccount] = useState(false);
  const [loadAccounts, setLoadAccounts] = useState(true);
  const [searchAccountTerm, setSearchAccountTerm] = useState({ name: "" });
  const [accounts, setAccounts] = useState([]);
  const [selectedAccount, setSelectedAccount] = useState();
  const [accountAction, setAccountAction] = useState();
  const [showAccountInformation, setShowAccountInformation] = useState(false);
  const [showCreateAccountViaCsvDialog, setShowCreateAccountViaCsvDialog] =
    useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showAccountForApprovalDialog, setShowAccountForApprovalDialog] =
    useState(false);
  const [totalAccountFormApproval, setTotalAccountFormApproval] = useState();
  const [autoSuggestAccounts, setAutoSuggestAccounts] = useState([]);
  const [hasMoreAccountsToLoad, setHasMoreAccountsToLoad] = useState(true);
  const [pageNumber, setPageNumber] = useState(1);
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const openMenu = Boolean(menuAnchorEl);
  const lastAccountsElementObserver = useRef();
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [isDownloadingAccount, setIsDownloadingAccount] = useState(false);
  const [downloadAccountProgress, setDownloadAccountProgress] =
    React.useState(0);
  const [csvFileToDelete, setCsvFileToDelete] = useState();
  const [
    showAccountDeleteProgressAndStatusDialog,
    setShowAccountDeleteProgressAndStatusDialog,
  ] = useState(false);
  const [deleteAccountProgress, setDeleteAccountProgress] = useState(0);
  const [deleteAccountErrors, setDeleteAccountErrors] = useState([]);
  const [showMessageDialogMessage, setShowMessageDialogMessage] =
    useState(false);
  const [message, setMessage] = useState();
  const [doneDeleting, setDoneDeleting] = useState(false);
  const [accountsLabel, setAccountLabel] = useState({});
  const [accountClassificationLabel, setAccountClassificationLabel] = useState(
    {}
  );
  const [isLoadingAccountLabel, setIsLoadingAccountLabel] = useState(true);

  // FOR QR CODE
  const [showQrCodeDialog, setShowQrCodeDialog] = useState(false);
  const [selectedQrCodeData, setSelectedQrCodeData] = useState("");

  const [data, setData] = useState("No result");
  const [showScanQRDialog, setShowScanQRDialog] = useState(false);
  useEffect(() => {
    if (!isLoadingAccountLabel) {
      return;
    }

    const getAccountsLabel = () => {
      const options = {
        method: "POST",
        url: "/TransactiLabels/getTransactiLiteLabels.json",
      };

      axios(options)
        .then((res) => {
          const labels = res.data.response;
          const accountLabel = labels.accounts;
          const accountClassificationsLabel = labels.account_classifications;

          setAccountLabel(accountLabel);
          setAccountClassificationLabel(accountClassificationsLabel);
          setIsLoadingAccountLabel(false);
        })
        .catch((error) => {
          console.log(error);
        });
    };

    getAccountsLabel();
  }, [accountsLabel, isLoadingAccountLabel]);

  const lastAccountsElement = useCallback(
    (node) => {
      if (isLoading) {
        return;
      }
      if (lastAccountsElementObserver.current) {
        lastAccountsElementObserver.current.disconnect();
      }
      lastAccountsElementObserver.current = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting && hasMoreAccountsToLoad) {
            lastAccountsElementObserver.current.disconnect();
            setPageNumber((prevPageNumber) => prevPageNumber + 1);
            setLoadAccounts(true);
          }
        }
      );

      if (node) {
        lastAccountsElementObserver.current.observe(node);
      }
    },
    [isLoading, hasMoreAccountsToLoad]
  );

  const editAccountClickListener = (event) => {
    setAccountAction("edit");
    setShowAccountInformation(false);
    setOpenCreateEditAccount(true);
  };
  const menuHandleClick = (event) => {
    setMenuAnchorEl(event.currentTarget);
  };

  function reloadAccounts() {
    setAccounts([]);
    setSearchAccountTerm({ name: "" });
    setPageNumber(1);
    setLoadAccounts(true);
  }

  useEffect(() => {
    getForApprovalAccountCount();
  }, []);

  useEffect(() => {
    function fetchAutoSuggesAccounts(searchString) {
      const loadAccounts = async () => {
        const options = {
          method: "POST",
          url: "/SellerAccounts/getSellerAccountsForAutoSuggest.json",
          data: objectToFormData({ search_term: searchString }),
        };
        await axios(options).then((res) => {
          const accounts = res.data.response.seller_accounts;
          if (accounts.length <= 0) {
            setAutoSuggestAccounts([]);
          } else {
            setAutoSuggestAccounts(accounts);
          }
        });
      };
      loadAccounts();
    }

    if (searchAccountTerm == null) {
      fetchAutoSuggesAccounts("");
    } else {
      fetchAutoSuggesAccounts(searchAccountTerm.name);
    }
  }, [searchAccountTerm]);

  useEffect(() => {
    if (!loadAccounts) {
      return;
    }
    fetchAccounts(searchAccountTerm.name);
  }, [loadAccounts, searchAccountTerm]);

  useEffect(() => {
    if (!doneDeleting) {
      return;
    }

    if (deleteAccountErrors.length <= 0) {
      setOpenDeleteDialog(false);
      setShowAccountDeleteProgressAndStatusDialog(false);
      setMessage("Accounts deleted successfully.");
      setShowMessageDialogMessage(true);
    }
  }, [doneDeleting]);

  const toDeleteCsvInputOnChagne = (event) => {
    let file = event.target.files;
    setCsvFileToDelete(file);
  };

  function fetchAccounts(searchValue) {
    setIsLoading(true);
    const options = {
      method: "POST",
      url: "/SellerAccounts/getSellerAccounts.json",
      data: objectToFormData({
        search_term: searchValue,
        page_number: pageNumber,
      }),
    };
    axios(options)
      .then((res) => {
        setIsLoading(false);
        setLoadAccounts(false);

        const isSuccess = res.data.response.is_success;
        if (!isSuccess) {
          alert("Error Loading accounts");
        }
        const accountsFromServer = res.data.response.seller_accounts;
        setHasMoreAccountsToLoad(accountsFromServer.length > 0);
        setAccounts(accounts.concat(accountsFromServer));
      })
      .catch((error) => {
        setIsLoading(false);
      });
  }
  function fetchAccountCountsForCSVDownload() {
    setIsDownloadingAccount(true);
    const options = {
      method: "POST",
      url: "/SellerAccounts/getAccountCounts.json",
    };
    axios(options)
      .then((res) => {
        let count = res.data.result.count;
        let limit = res.data.result.limit;
        if (!count > 0) {
          // no account to download
          setShowMessageDialogMessage(true);
          setMessage("No Available account to download.");
          setIsDownloadingAccount(false);
        } else {
          const total_page = Math.ceil(count / limit);
          fetchAccountForCSVDownload(0, limit, total_page, "");
        }
      })
      .catch((error) => {
        setIsDownloadingAccount(false);
        alert("Error encouter.");
      });
  }
  async function readToDeleteCsv(csvFile) {
    try {
      let file = csvFile[0];
      let is_valid_file = file !== undefined && file.type === "text/csv";
      if (!is_valid_file) {
        alert("Please select a valid csv file");
        return;
      }

      let csv_data = await readCsv(file);
      let csv_header = csv_data.header;
      let csv_values = csv_data.data;
      let missingHeaders = getMissingHeaders(csv_header, [
        accountsLabel.singular + " code*",
        accountsLabel.singular + " name",
      ]);
      if (csv_header.length <= 0) {
        alert("Check your csv header");
        return;
      }
      if (missingHeaders.length > 0) {
        alert(
          "The following headers must be in your CSV header: " +
            missingHeaders.join(", ")
        );
        return;
      }

      let upload_data_limit = 5;
      uploadAccountToDelete(upload_data_limit, csv_values, csv_values.length);

      setShowAccountDeleteProgressAndStatusDialog(true);
    } catch (error) {
      console.error("Failed to parse CSV:", error);
    }
  }

  function readCsv(csvFile) {
    return new Promise((resolve, reject) => {
      Papa.parse(csvFile, {
        header: true,
        skipEmptyLines: true,
        complete: function (results) {
          resolve({ header: results.meta.fields, data: results.data });
        },
        error: function (error) {
          reject(error);
        },
      });
    });
  }
  function getMissingHeaders(csvHeaderArray, requiredHeaderArray) {
    return requiredHeaderArray.filter(
      (header) => !csvHeaderArray.includes(header)
    );
  }
  function uploadAccountToDelete(
    upload_data_limit,
    data_to_upload,
    total_record_count
  ) {
    // Get the first two records
    const chunk_of_data_to_upload = data_to_upload.slice(0, upload_data_limit);
    // Update data_to_upload by removing data to upload
    data_to_upload.splice(0, upload_data_limit);

    var accounts = JSON.stringify(chunk_of_data_to_upload);

    const options = {
      method: "POST",
      url: "/SellerAccounts/deleteAccounts.json",
      data: objectToFormData({ accounts: accounts }),
    };
    axios(options)
      .then((res) => {
        let result = res.data.result;
        let is_success = result.is_success;
        let errors = result.errors;
        let remaining_data_to_delete = data_to_upload.length;
        let progress =
          ((total_record_count - remaining_data_to_delete) /
            total_record_count) *
          100;

        setDeleteAccountErrors((deleteAccountErrors) => [
          ...deleteAccountErrors,
          ...errors,
        ]);

        setDeleteAccountProgress(progress);

        if (data_to_upload.length > 0) {
          uploadAccountToDelete(
            upload_data_limit,
            data_to_upload,
            total_record_count
          );
        } else {
          setDoneDeleting(true);
        }
      })
      .catch((error) => {
        alert("Error encouter.");
      });
  }
  async function fetchAccountForCSVDownload(
    offset = 0,
    limit,
    total_page,
    downloadCsvContent
  ) {
    let progress = (offset / total_page) * 100;
    if (offset < total_page) {
      await axios({
        method: "POST",
        url: "/SellerAccounts/getAccountForCSV.json",
        data: objectToFormData({ offset: offset, limit: limit }),
      }).then((res) => {
        res.data.result.accounts.forEach((account) => {
          downloadCsvContent +=
            account.account_code + " " + "," + account.account_name + "\n";
        });
      });
      fetchAccountForCSVDownload(
        offset + 1,
        limit,
        total_page,
        downloadCsvContent
      );
      setDownloadAccountProgress(progress);
    } else {
      setDownloadAccountProgress(0);
      downloadFile(downloadCsvContent, "accounts_to_delete");
      setIsDownloadingAccount(false);
    }
  }

  function downloadFile(csv_data) {
    let file_name = accountsLabel.plural + " to delete";
    let header =
      accountsLabel.singular + " code*," + accountsLabel.singular + " name";
    let csv = header + "\n" + csv_data;
    const url = "data:text/csv;charset=utf-8," + encodeURIComponent(csv);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `${file_name}.csv`);
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  function getForApprovalAccountCount() {
    setIsLoading(true);

    const options = {
      method: "POST",
      url: "/TransactiSellerPotentialAccounts/getTotalPotentialAccountForApproval.json",
      data: objectToFormData({ search_term: "" }),
    };
    axios(options)
      .then((res) => {
        setIsLoading(false);

        const isSuccess = res.data.response.is_success;

        if (!isSuccess) {
          alert("Error encounter");

          return;
        }
        const totalAccountForApproval =
          res.data.response.total_account_for_approval;
        setTotalAccountFormApproval(totalAccountForApproval);
      })
      .catch((error) => {
        setIsLoading(false);
        alert("Error encounter");
      });
  }
  const objectToFormData = (object) =>
    Object.keys(object).reduce((formData, key) => {
      formData.append(key, object[key]);
      return formData;
    }, new FormData());

  function autoComplete() {
    return (
      <Autocomplete
        value={searchAccountTerm}
        noOptionsText="No records found."
        onChange={(event, newValue) => {
          if (newValue === null || newValue.name === "") {
            searchAccountTerm.name = "";
            return;
          }
          searchAccountTerm.name = newValue.name;
          setAccounts([]);
          setPageNumber(1);
          setLoadAccounts(true);
        }}
        selectOnFocus
        clearOnBlur
        handleHomeEndKeys
        options={autoSuggestAccounts}
        isOptionEqualToValue={() => true}
        getOptionLabel={(option) => {
          return option.name;
        }}
        renderOption={(props, option) => {
          return (
            <li {...props} key={option.id}>
              {option.name}
            </li>
          );
        }}
        style={{ width: "100%", paddingLeft: "8px" }}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="standard"
            InputProps={{ ...params.InputProps, disableUnderline: true }}
            onChange={(event) => {
              setSearchAccountTerm({ name: event.target.value });
            }}
          />
        )}
      />
    );
  }
  function search() {
    return (
      <div
        position="static"
        style={{
          border: ".1rem solid #989898",
          borderRadius: "4px",
          margin: "2px",
        }}
      >
        <Toolbar variant="dense" style={{ padding: "0" }}>
          <Box flexGrow={1}>{autoComplete()}</Box>
          <Box>
            <IconButton
              className={classes.margin}
              size="large"
              onClick={() => {
                setAccounts([]);
                setPageNumber(1);
                setLoadAccounts(true);
              }}
            >
              <SearchIcon />
            </IconButton>
          </Box>
        </Toolbar>
      </div>
    );
  }
  function accountElement(account) {
    return (
      <div style={{ width: "100%" }}>
        <Typography variant="h6" sx={{ fontWeight: "bold" }}>
          {account.account_name}
        </Typography>
        <Typography variant="h7">#: {account.contact_number}</Typography>
        <Typography variant="body1" gutterBottom>
          {account.street} {account.barangay} {account.city_municipality}{" "}
          {account.province}
        </Typography>
        <div
          style={{
            display: "flex", // Enable Flexbox layout
            justifyContent: "flex-end", // Align items to the right
            marginTop: "1em", // Optional, adds space between text and button
          }}
        >
          <Button
            variant="contained"
            color="primary"
            onClick={(e) => handleGenerateQrCode(e, account)}
          >
            <QrCodeIcon /> &nbsp; Generate QR Code
          </Button>
        </div>
      </div>
    );
  }

  const handleScanQrCode = (e, account) => {
    e.stopPropagation();

    setShowScanQRDialog(true);
  };

  const handleGenerateQrCode = (e, account) => {
    e.stopPropagation();

    const qr_code_data = {
      code: account.account_code,
      company_id: account.seller_company_id,
    };

    setSelectedQrCodeData(JSON.stringify(qr_code_data));
    setShowQrCodeDialog(true);
  };
  function QrCodeDialog() {
    return (
      <Dialog fullWidth={true} maxWidth={"sm"} open={showQrCodeDialog}>
        <DialogTitle id="alert-dialog-title">{"QR CODE"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "400px",
                width: "100%",
              }}
            >
              <QRCode
                size={256} // Large QR code resolution
                style={{ width: "100%", height: "auto", maxWidth: "400px" }}
                value={selectedQrCodeData}
              />
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setShowQrCodeDialog(false);
            }}
            color="primary"
            autoFocus
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
  function QrCodeReaderDialog() {}

  function deleteAccountViaCSVDialog() {
    return (
      <Dialog fullWidth={true} maxWidth={"md"} open={openDeleteDialog}>
        <DialogTitle>
          Delete{" "}
          {Object.keys(accountsLabel).length === 0
            ? "Accounts"
            : accountsLabel.plural}{" "}
          via CSV
        </DialogTitle>
        <DialogContent>
          <Box
            p={1}
            display="flex"
            justifyContent="left"
            flexDirection="column"
          >
            <input
              accept=".csv"
              type="file"
              onChange={toDeleteCsvInputOnChagne}
            />
            <br />
          </Box>
          <Button
            variant="contained"
            style={{ marginRight: "5px" }}
            color="primary"
            onClick={() => {
              fetchAccountCountsForCSVDownload();
            }}
          >
            <FileDownloadIcon /> Download template with{" "}
            {Object.keys(accountsLabel).length === 0
              ? "Accounts"
              : accountsLabel.plural}{" "}
          </Button>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              readToDeleteCsv(csvFileToDelete);
            }}
            color="primary"
          >
            Continue
          </Button>
          <Button
            onClick={() => {
              setOpenDeleteDialog(false);
            }}
            color="primary"
            autoFocus
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
  function progressDialog() {
    return (
      <Dialog
        fullWidth={true}
        maxWidth={"lg"}
        open={isDownloadingAccount}
        onClose={() => {}}
      >
        <DialogContent>
          <DialogContentText>
            Downloading{" "}
            {Object.keys(accountsLabel).length === 0
              ? "Accounts"
              : accountsLabel.plural}{" "}
            ... Please wait...
          </DialogContentText>
          <Box sx={{ width: "100%" }}>
            <LinearProgress
              color="secondary"
              variant="determinate"
              value={downloadAccountProgress}
            />
          </Box>
        </DialogContent>
      </Dialog>
    );
  }
  function accountDeleteProgressAndStatusTable() {
    if (deleteAccountErrors.length > 0) {
      return (
        <TableContainer component={Paper}>
          <Table
            sx={{ minWidth: 500 }}
            aria-label="caption table"
            id="status_tbl"
          >
            <TableHead>
              <TableRow>
                <TableCell>
                  <b>Error message</b>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {deleteAccountErrors.map((value, index) => (
                <TableRow key={index}>
                  <TableCell>{value}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      );
    } else {
      return "";
    }
  }

  function accountDeleteProgressAndStatusDialog() {
    return (
      <Dialog
        fullWidth={true}
        maxWidth={"md"}
        open={showAccountDeleteProgressAndStatusDialog}
      >
        <DialogTitle>
          Delete{" "}
          {Object.keys(accountsLabel).length === 0
            ? "Accounts"
            : accountsLabel.plural}{" "}
          progress and status
        </DialogTitle>
        <DialogContent>
          <LinearProgress
            sx={{ height: 10 }}
            variant="determinate"
            value={deleteAccountProgress}
          />
          {accountDeleteProgressAndStatusTable()}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setShowAccountDeleteProgressAndStatusDialog(false);
              setOpenDeleteDialog(false);
              window.location.reload();
            }}
            color="primary"
            autoFocus
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  function messageDialog() {
    return (
      <Dialog fullWidth={true} maxWidth={"sm"} open={showMessageDialogMessage}>
        <DialogTitle id="alert-dialog-title">{"Message"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {message}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setShowMessageDialogMessage(false);
              window.location.reload();
            }}
            color="primary"
            autoFocus
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  return (
    <div>
      <CssBaseline />
      <AppBar position="fixed" className={classes.appBar}>
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={props.handleDrawerToggle}
            className={classes.menuButton}
            size="large"
          >
            <MenuIcon />
          </IconButton>

          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            Manage{" "}
            {Object.keys(accountsLabel).length === 0
              ? "Accounts"
              : accountsLabel.plural}
          </Typography>
          <Button
            color="inherit"
            onClick={() => {
              setShowAccountForApprovalDialog(true);
            }}
          >
            For approval
          </Button>
          <Badge
            badgeContent={totalAccountFormApproval}
            showZero
            color="secondary"
            style={{ marginLeft: "1rem", marginRight: ".5rem" }}
            onClick={() => {
              setShowAccountForApprovalDialog(true);
            }}
          />

          <IconButton
            className={classes.margin}
            onClick={menuHandleClick}
            edge="end"
          >
            <MoreVertIcon />
          </IconButton>
          <Menu
            id="simple-menu"
            open={openMenu}
            anchorEl={menuAnchorEl}
            onClose={() => {
              setMenuAnchorEl(null);
            }}
          >
            <MenuItem
              onClick={() => {
                setOpenDeleteDialog(true);
                setMenuAnchorEl(null);
              }}
            >
              Delete{" "}
              {Object.keys(accountsLabel).length === 0
                ? "Accounts"
                : accountsLabel.plural}{" "}
              via csv
            </MenuItem>
          </Menu>
        </Toolbar>
      </AppBar>
      {search()}
      {isLoading ? (
        <LinearProgress
          color="secondary"
          style={{ marginLeft: ".1rem", marginRight: ".1rem" }}
        />
      ) : (
        ""
      )}
      <List>
        {accounts.map((account, index) =>
          accounts.length === index + 1 ? (
            <React.Fragment key={account.id}>
              <ListItem
                ref={lastAccountsElement}
                key={account.id}
                sx={{ cursor: "pointer" }}
                onClick={() => {
                  setSelectedAccount(account);
                  setShowAccountInformation(true);
                }}
                divider
              >
                {/* <ListItemAvatar>
                  <Avatar
                    onClick={(event) => {}}
                    sx={{ width: 56, height: 56 }}
                    src={account.image_path === "" ? account.image : account.image_path}
                  />
                </ListItemAvatar> */}
                {accountElement(account)}
              </ListItem>
            </React.Fragment>
          ) : (
            <React.Fragment key={account.id}>
              <ListItem
                key={account.id}
                sx={{ cursor: "pointer" }}
                onClick={() => {
                  setSelectedAccount(account);
                  setShowAccountInformation(true);
                }}
                divider
              >
                {/* <ListItemAvatar>
                  <Avatar
                    onClick={(event) => {}}
                    sx={{ width: 56, height: 56 }}
                    src={
                      account.image_path === ""
                        ? account.image
                        : account.image_path
                    }
                  />
                </ListItemAvatar> */}
                {accountElement(account)}
              </ListItem>
            </React.Fragment>
          )
        )}
      </List>
      <AppBar
        position="fixed"
        style={{ background: "transparent", boxShadow: "none" }}
        className={classes.appBarBottom}
      >
        <Toolbar>
          <div className={classes.grow} />
          <Fab
            variant="extended"
            size="medium"
            color="primary"
            aria-label="add"
            className={classes.margin}
            style={{ marginRight: ".5rem" }}
            onClick={() => {
              setShowCreateAccountViaCsvDialog(true);
            }}
          >
            <AddIcon className={classes.extendedIcon} />
            Add{" "}
            {Object.keys(accountsLabel).length === 0
              ? "Accounts"
              : accountsLabel.plural}{" "}
            via CSV
          </Fab>
          <Fab
            variant="extended"
            size="medium"
            color="primary"
            aria-label="add"
            className={classes.margin}
            onClick={() => {
              setAccountAction("add");
              setOpenCreateEditAccount(true);
            }}
          >
            <AddIcon className={classes.extendedIcon} />
            Add{" "}
            {Object.keys(accountsLabel).length === 0
              ? "Account"
              : accountsLabel.singular}
          </Fab>
        </Toolbar>
        {loadAccounts ? (
          <LinearProgress
            color="secondary"
            style={{ marginLeft: ".1rem", marginRight: ".1rem" }}
          />
        ) : (
          ""
        )}
      </AppBar>
      {openCreateEditAccount ? (
        <CreateEditAccount
          reloadAccounts={reloadAccounts}
          selectedAccount={selectedAccount}
          setSelectedAccount={setSelectedAccount}
          setAccountAction={setAccountAction}
          accountAction={accountAction}
          openCreateEditAccount={openCreateEditAccount}
          setOpenCreateEditAccount={setOpenCreateEditAccount}
          accountsLabel={accountsLabel}
          accountClassificationLabel={accountClassificationLabel}
        />
      ) : (
        ""
      )}
      {
        <ViewAccountInformation
          selectedAccount={selectedAccount}
          editAccountClickListener={editAccountClickListener}
          showAccountInformation={showAccountInformation}
          setShowAccountInformation={setShowAccountInformation}
          accountsLabel={accountsLabel}
          accountClassificationLabel={accountClassificationLabel}
        ></ViewAccountInformation>
      }
      {showCreateAccountViaCsvDialog ? (
        <CreateAccountViaCSV
          showCreateAccountViaCsvDialog={showCreateAccountViaCsvDialog}
          setShowCreateAccountViaCsvDialog={setShowCreateAccountViaCsvDialog}
          accountsLabel={accountsLabel}
          accountClassificationLabel={accountClassificationLabel}
        />
      ) : (
        ""
      )}
      {showAccountForApprovalDialog ? (
        <AccountsForApprovalDialog
          accountsLabel={accountsLabel}
          showAccountForApprovalDialog={showAccountForApprovalDialog}
          setShowAccountForApprovalDialog={setShowAccountForApprovalDialog}
        />
      ) : (
        ""
      )}
      <ThemeProvider theme={materialTheme}>
        {deleteAccountViaCSVDialog()}
        {progressDialog()}
        {accountDeleteProgressAndStatusDialog()}
        {messageDialog()}
        {QrCodeDialog()}
        {QrCodeReaderDialog()}
      </ThemeProvider>
    </div>
  );
}

export default Accounts;
